<div #hoverTipRef class="hover-tip" [innerHTML]="title"></div>
